import React from 'react';
import PropTypes from 'prop-types';

function SubtypeSelect({ htmlId, subtypes, subtypeId, required, subtypePrompt, subtypeLabel, onChange }) {
  if (subtypes.length === 0) {
    // A type with require_subtype: true but zero active subtypes (e.g. all its
    // subtypes were deactivated) can't be satisfied by this picker: the hidden
    // valve_subtype_id input would submit blank and the server rejects the
    // write with a 422 (ValveTypeAssignable's presence validation). Surface
    // that here instead of silently rendering nothing, so the gap is visible
    // before the user hits an opaque save failure.
    if (required) {
      return (
        <div className="control-group error">
          <label className="control-label" htmlFor={htmlId}>
            {subtypeLabel}
          </label>
          <div className="controls">
            <span className="help-inline">
              This valve type requires a subtype, but none are available. Add a subtype to this valve type in Settings
              before assigning it to a device.
            </span>
          </div>
        </div>
      );
    }

    return null;
  }

  return (
    <div className="control-group">
      <label className="control-label" htmlFor={htmlId}>
        {subtypeLabel}
      </label>
      <div className="controls">
        <select
          id={htmlId}
          className="span12"
          required={required}
          value={subtypeId === null ? '' : subtypeId}
          onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}>
          <option value="">{subtypePrompt}</option>
          {subtypes.map((subtype) => (
            <option key={subtype.id} value={subtype.id}>
              {subtype.type_name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

SubtypeSelect.propTypes = {
  htmlId: PropTypes.string.isRequired,
  subtypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type_name: PropTypes.string.isRequired
    })
  ).isRequired,
  subtypeId: PropTypes.number,
  required: PropTypes.bool,
  subtypePrompt: PropTypes.string.isRequired,
  subtypeLabel: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

SubtypeSelect.defaultProps = {
  subtypeId: null,
  required: false
};

export default SubtypeSelect;
